// extracted by mini-css-extract-plugin
export default {"container":"RateSummaryOpportunities_container__s650q"};